<template>
  <b-modal :active="value" has-modal-card full-screen @close="close()">
    <form action>
      <div class="modal-card" style="width: 100%;">
        <header class="modal-card-head">
          <p class="modal-card-title" style="color: whitesmoke; text-align: left">署名</p>
        </header>
        <section class="modal-card-body" style="width: 100%;">
          <div align="center" id="divCanvas" class="columns" style="width: 100%;height: 500px;">
            <canvas class="is-full" id="signCanvas" style="border:5px solid #ccc;width: 100%;"></canvas>
          </div>
          <div class="columns" style="text-align: left;">
            <div class="column is-full">
              <b-checkbox
                v-model="checkConsent"
                :disabled="flag"
                @click.native="inputReason()"
                style="font-size: 16px; font-weight: bold"
              >代理サイン</b-checkbox>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <span style="font-size: 16px; font-weight: bold;">代理サイン理由</span>
              <b-field
                :type="{'is-danger':errors.has('alternativeWritingReason')}"
                :message="errors.first('alternativeWritingReason')"
              >
                <b-input
                  v-model="alternativeWritingReason"
                  name="alternativeWritingReason"
                  :readonly="flag"
                  data-vv-as="代筆理由"
                  v-validate="'max:50'"
                  maxlength="50"
                />
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button class="button" type="button" @click="signUp()">登録する</b-button>
          <b-button class="button" type="button" @click="clearCanvas()">クリア</b-button>
          <span style="color: white" v-if="flag">※既に署名済みの為、編集できません。再入力する場合は「クリアボタン」押下して下さい。</span>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
let canvas;
let ctx;
let moveflg = 0;
let Xpoint = 0;
let Ypoint = 0;
let defSize = 5;
let defColor = "#555";

export default {
  name: "Sign",

  props: [
    "value",
  ],

  data() {
    return {
      signData: "",
      alternativeWritingReason: "",
      checkConsent: false,
      flag: false,
    };
  },

  methods: {
    close: function() {
      this.$emit("input", false);
      return;
    },

    signUp: function(event) {
      this.$validator.validateAll().then(async validatorResult => {
        if (validatorResult) {
          // 署名をイメージに変換
          let signData = document.getElementById("signCanvas").toDataURL();
          signData = signData.replace("data:image/png;base64,", "");
          // サインチェック
          if (this.flag || ctx.strokeStyle == "#555555") {
            // 代理サインフラグ
            const signFlg = this.checkConsent;
            // 代理サイン理由
            const signReason = this.alternativeWritingReason;
            if (
              this.flag ||
              (!signFlg && signReason == "") ||
              (signFlg && signReason != "")
            ) {
              const signInfo = {
                signData: signData,
                signFlg: signFlg,
                signReason: signReason,
                signed: this.flag,
              }
              this.$emit("signed", signInfo);
              this.close();
            } else {
              // エラーメッセージ表示
              this.showErrorMessage("代筆サインまたは、代筆理由が未入力です。");
            }
          } else {
            // エラーメッセージ表示
            this.showErrorMessage("署名が未入力です。");
          }
        }
      });

      return;
    },

    clearCanvas: function(event) {
      if (this.flag) {
        this.flag = false;
        // PC対応
        canvas.addEventListener("mousedown", this.startPoint, false);
        canvas.addEventListener("mousemove", this.movePoint, false);
        canvas.addEventListener("mouseup", this.endPoint, false);
        // スマホ対応
        canvas.addEventListener("touchstart", this.startPoint, false);
        canvas.addEventListener("touchmove", this.movePoint, false);
        canvas.addEventListener("touchend", this.endPoint, false);
      }
      ctx.clearRect(
        0,
        0,
        ctx.canvas.clientWidth + 10,
        ctx.canvas.clientHeight + 10
      );
      ctx.strokeStyle = "#000000";
      // フォーカスを外す
      const active_element = document.activeElement;
      if (active_element) {
        active_element.blur();
      }

      return;
    },

    startPoint: function(e) {
      e.preventDefault();
      ctx.beginPath();
      if (!e.offsetX) {
        Xpoint = e.touches[0].pageX - e.touches[0].target.offsetLeft;
      } else {
        Xpoint = e.offsetX;
      }
      if (!e.offsetY) {
        Ypoint = e.touches[0].pageY - e.touches[0].target.offsetTop;
      } else {
        Ypoint = e.offsetY;
      }
      ctx.moveTo(Xpoint, Ypoint);

      return;
    },

    movePoint: function(e) {
      if (e.buttons === 1 || e.witch === 1 || e.type === "touchmove") {
        if (!e.offsetX) {
          Xpoint = e.touches[0].pageX - e.touches[0].target.offsetLeft;
        } else {
          Xpoint = e.offsetX;
        }
        if (!e.offsetY) {
          Ypoint = e.touches[0].pageY - e.touches[0].target.offsetTop;
        } else {
          Ypoint = e.offsetY;
        }
        moveflg = 1;
        ctx.lineTo(Xpoint, Ypoint);
        ctx.lineCap = "round";
        ctx.lineWidth = defSize * 2;
        ctx.strokeStyle = defColor;
        ctx.stroke();
      }

      return;
    },

    endPoint: function(e) {
      if (moveflg === 0) {
        ctx.lineTo(Xpoint - 1, Ypoint - 1);
        ctx.lineCap = "round";
        ctx.lineWidth = defSize * 2;
        ctx.strokeStyle = defColor;
        ctx.stroke();
      }
      moveflg = 0;

      return;
    },

    inputReason() {
      if (!this.checkConsent) {
        this.alternativeWritingReason =
          "本人、ご家族の許可を得て代理サインしております。";
      } else {
        this.alternativeWritingReason = "";
      }

      return;
    }
  },

  mounted: function() {
    canvas = document.getElementById("signCanvas");
    canvas.width = divCanvas.clientWidth;
    canvas.height = divCanvas.clientHeight;
    ctx = canvas.getContext("2d");
    if (this.flag) {
      // サイン画像表示
      var img = new Image();
      img.src =
        "data:image/png;base64," +
        Buffer.from(this.signData).toString("base64");
      img.onload = function() {
        ctx.canvas.width = divCanvas.clientWidth;
        ctx.canvas.height = divCanvas.clientHeight;
        ctx.drawImage(img, 0, 0);
      };
    } else {
      // PC対応
      canvas.addEventListener("mousedown", this.startPoint, false);
      canvas.addEventListener("mousemove", this.movePoint, false);
      canvas.addEventListener("mouseup", this.endPoint, false);
      // スマホ対応
      canvas.addEventListener("touchstart", this.startPoint, false);
      canvas.addEventListener("touchmove", this.movePoint, false);
      canvas.addEventListener("touchend", this.endPoint, false);
    }

    return;
  },

  watch: {},

  filters: {}
};
</script>



// WEBPACK FOOTER //
// src/components/common/Sign.vue